<div class="fixed top-0 left-0 bottom-0 right-0 bg-white z-[9999] overflow-y-auto">
  <div class="max-w-[1200px] mx-auto py-[60px]">
    <header class="flex flex-row items-center justify-between">
      <img src="/assets/logo/login_logo_en.png" height="45" alt="" />

      <div class="flex flex-row">
        <img src="/assets/v4/guide-close.png" width="50" class="cursor-pointer" alt="" (click)="onClickClose()" />
      </div>
    </header>

    <section class="px-[100px] pt-[100px]">
      <div class="col-2">
        <div class="col" *ngIf="step === 1">
          <div class="col-wrapper">
            <div class="col-header">
              <div class="col-title">
                {{ "channel-link_rt_note_html_title1" | translate }}
                <!-- Want to link the listing to the room type? -->
              </div>

              <div>
                <div class="col-content">
                  {{ "channel-link_rt_note_html_content1-1" | translate }}
                  <!-- You only need to link the listing to the room type in the following situations: -->
                </div>
                <ul class="col-content pl-[40px]">
                  <li style="list-style: auto">
                    {{ "channel-link_rt_note_html_content1-2" | translate }}
                    <!-- You already have multi-inventory listings/room types on Booking.com or other platforms. -->
                  </li>
                  <li style="list-style: auto">
                    {{ "channel-link_rt_note_html_content1-3" | translate }}
                    <!-- You wish to set up your Airbnb listing as multi-inventory (meaning that the listing will not be
                    closed after being booked once). -->
                  </li>
                </ul>
                <div class="col-content">
                  {{ "channel-link_rt_note_html_content1-4" | translate }}
                  <!-- Incorrect linking may cause confusion in your calendar. -->
                  <a [href]="roomTypesDoc" target="_blank">
                    {{ "channel-link_rt_note_html_content1-4-link" | translate }}
                    <!-- More details about room type → -->
                  </a>
                </div>
              </div>

              <div class="mt-[36px]">
                <button nz-button nzType="primary" nzSize="large" nzBlock (click)="step = 2">
                  {{ "channel-link_rt_note_html_understand" | translate }}
                  <!-- I understand and would like to proceed -->
                </button>
                <button class="mt-[16px]" nz-button nzSize="large" nzBlock (click)="onClickClose()">
                  {{ "channel-link_rt_note_html_not_sure" | translate }}
                  <!-- I’m not sure -->
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col" *ngIf="step === 2">
          <div class="col-wrapper">
            <div class="col-header">
              <div class="col-title">
                {{ "channel-link_rt_note_html_title2" | translate }}
                <!-- You also need to know … -->
              </div>

              <div>
                <div class="col-content">
                  {{ "channel-link_rt_note_html_content2-1" | translate }}
                  <!-- After you link the listing to the room type, the system will act as follows: -->
                </div>
                <ul class="col-content pl-[40px]">
                  <li style="list-style: auto">
                    {{ "channel-link_rt_note_html_content2-2" | translate }}
                    <!-- When a new reservation from a platform is received, the system will search for available properties
                    within the linked room type and assign the reservation to one of them. -->
                  </li>
                  <li style="list-style: auto">
                    {{ "channel-link_rt_note_html_content2-3" | translate }}
                    <!-- After the reservation is assigned, the system will calculate the current number of available
                    properties remaining in the room type and push this value to the platforms linked to this room type. -->
                  </li>
                  <li style="list-style: auto">
                    {{ "channel-link_rt_note_html_content2-4" | translate }}
                    <!-- If a property within the room type is linked with other platforms, the system will also close the
                    availability of the linked platforms. -->
                  </li>
                </ul>
              </div>

              <div class="mt-[36px]">
                <button nz-button nzType="primary" nzSize="large" nzBlock (click)="onClickFinish()">
                  {{ "channel-link_rt_note_html_understand" | translate }}
                  <!-- I understand and would like to proceed -->
                </button>
                <button class="mt-[16px]" nz-button nzSize="large" nzBlock (click)="onClickClose()">
                  {{ "channel-link_rt_note_html_not_sure" | translate }}
                  <!-- I’m not sure -->
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <img src="/assets/v4/register-welcome.svg" width="100%" alt="" />
        </div>
      </div>
    </section>
  </div>
</div>
